import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject, Subscription } from 'rxjs';
import { ConfirmationService } from "primeng/api";

@Component({
  selector: 'app-employer-labour-condition-statement',
  templateUrl: './employer-labour-condition-statement.component.html',
  styleUrls: ['./employer-labour-condition-statement.component.scss']
})
export class EmployerLabourConditionStatementComponent implements OnInit , OnChanges {  
  @Input() EmpLCS: FormGroup;
  @Input()  EmpLCSEdit:any;
  @Output() change: EventEmitter<boolean> = new EventEmitter<boolean>();
  isDuplicateLCA: boolean = false;

  constructor(private confirmationService: ConfirmationService) { }

  ngOnInit(): void {
    this.isDuplicateLCA = sessionStorage.getItem("isDuplicateLCA") === 'true';
    this.EmpLCSEdit = JSON.parse(localStorage.getItem("userEfileInfo"));   
    if (this.EmpLCSEdit && this.EmpLCSEdit.lcaApplication.status.name === "Not Certified"){
      this.EmpLCS.patchValue({
        cbEmp:true,
      });
    }
  }

  checkCheckBoxvalueEmp(event){
    // console.log('event.checkedevent.checkedevent.checkedevent.checked',event.checked)
    this.EmpLCS.patchValue({
      cbEmp:event.checked,
    })
  }

  opened() {
    this.change.emit(true);
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes.EmpLCSEdit.currentValue && changes.EmpLCSEdit.currentValue.placeList.length > 0){
      if(JSON.parse(localStorage.getItem('userEfileInfo'))){
          this.EmpLCS.patchValue({
            cbEmp:true,
          });
      }
    }
  }
  clearData() {
    // Clear any previous confirmation
    this.confirmationService.close();

    this.confirmationService.confirm({
      header: "Clear Data",
      icon: "pi pi-exclamation-triangle",
      rejectLabel: "Cancel",
      acceptLabel: "Yes, Clear Data",
      acceptButtonStyleClass: "btn-accept-clear",
      rejectButtonStyleClass: "btn-cancel-clear",
      message: `<div class="mb-4"> This will clear all the data from this section. </div>
                <div class="mb-4"> Are you sure, you want to clear data? </div>`,
      accept: () => {
        this.EmpLCS.reset();
        this.confirmationService.close();
      },
      reject: () => {
        // Clear the confirmation dialog instance after rejection
       this.confirmationService.close();
     },
    });
  }
}